import React from "react";
import { Box, FormControl, Select, MenuItem } from "@mui/material";
import { ReactComponent as GradientInputBorder } from "../../assets/gradient-input-border.svg";

export interface GradientBorderSelectProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  options: { value: string; label: string }[];
  width?: number;
}

export const GradientBorderSelect: React.FC<GradientBorderSelectProps> = ({
  value,
  onChange,
  label,
  options,
  width = 240,
}) => {
  return (
    <Box sx={{ position: "relative", width, height: 40 }}>
      <GradientInputBorder
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <FormControl
        size="small"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
      >
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
          sx={{
            width: "100%",
            height: "100%",
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
            backgroundColor: "transparent",
            borderRadius: "4px",
            "& .MuiSelect-select": {
              padding: "8px 12px",
              display: "flex",
              alignItems: "center",
            },
          }}
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{ color: "#999" }}>{label}</span>;
            }
            return (
              options.find((option) => option.value === selected)?.label || selected
            );
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
